import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { themeable } from '@instructure/ui-themeable';
import { omitProps, getElementType } from '@instructure/ui-react-utils';
import { hasVisibleChildren } from '@instructure/ui-a11y-utils';
var styles = {
  componentId: 'fCrpb',
  template: function template(theme) {
    return "\n\n.fCrpb_bGBk,.fCrpb_bGBk.fCrpb_fVUh,label.fCrpb_bGBk{all:initial;animation:none 0s ease 0s 1 normal none running;backface-visibility:visible;background:transparent none repeat 0 0/auto auto padding-box border-box scroll;border:medium none currentColor;border-collapse:separate;border-image:none;border-radius:0;border-spacing:0;bottom:auto;box-shadow:none;box-sizing:content-box;caption-side:top;clear:none;clip:auto;color:#000;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-span:1;column-width:auto;columns:auto;content:normal;counter-increment:none;counter-reset:none;cursor:auto;direction:ltr;display:inline;display:block;empty-cells:show;float:none;font-family:serif;font-size:medium;font-stretch:normal;font-style:normal;font-variant:normal;font-weight:400;height:auto;hyphens:none;left:auto;letter-spacing:normal;line-height:normal;list-style:disc outside none;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;orphans:2;outline:medium none invert;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;position:static;right:auto;tab-size:8;table-layout:auto;text-align:left;text-align-last:auto;text-decoration:none;text-indent:0;text-shadow:none;text-transform:none;top:auto;transform:none;transform-origin:50% 50% 0;transform-style:flat;transition:none 0s ease 0s;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:2;width:auto;word-spacing:normal;z-index:auto}\n\n.fCrpb_bGBk.fCrpb_fVUh{display:table;width:100%}\n\n.fCrpb_egrg,.fCrpb_egrg.fCrpb_fVUh,label.fCrpb_egrg{color:".concat(theme.color || 'inherit', ";font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";margin:0;text-align:inherit}\n\n[dir=ltr] .fCrpb_egrg,[dir=ltr] .fCrpb_egrg.fCrpb_fVUh,[dir=ltr] label.fCrpb_egrg,[dir=rtl] .fCrpb_egrg,[dir=rtl] .fCrpb_egrg.fCrpb_fVUh,[dir=rtl] label.fCrpb_egrg{text-align:inherit}");
  },
  'root': 'fCrpb_bGBk',
  'legend': 'fCrpb_fVUh',
  'has-content': 'fCrpb_egrg'
};
import theme from "./theme.js";
/**
---
parent: FormField
---

This is a helper component that is used by most of the custom form
components. In most cases it shouldn't be used directly.

```js
---
example: true
---
<FormFieldLabel>Hello</FormFieldLabel>
```

**/

var FormFieldLabel = (_dec = themeable(theme, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FormFieldLabel, _Component);

  var _super = _createSuper(FormFieldLabel);

  function FormFieldLabel() {
    _classCallCheck(this, FormFieldLabel);

    return _super.apply(this, arguments);
  }

  _createClass(FormFieldLabel, [{
    key: "render",
    value: function render() {
      var _classes;

      var ElementType = getElementType(FormFieldLabel, this.props);
      var classes = (_classes = {}, _defineProperty(_classes, styles.root, true), _defineProperty(_classes, styles['has-content'], hasVisibleChildren(this.props.children)), _classes);
      return /*#__PURE__*/React.createElement(ElementType, Object.assign({}, omitProps(this.props, FormFieldLabel.propTypes), {
        className: classnames(classes)
      }), this.props.children);
    }
  }]);

  FormFieldLabel.displayName = "FormFieldLabel";
  return FormFieldLabel;
}(Component), _class2.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired
}, _class2.defaultProps = {
  as: 'span'
}, _temp)) || _class);
export default FormFieldLabel;
export { FormFieldLabel };